import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Login from "../Login";
import { userService } from "@/services/user.service";
import Utils from "@/utils";
import config from "@/environments/config";

function LogInRoute({ onOktaDetected, oktaConfigUpdated }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get("returnTo");
  const mcpState = searchParams.get("state");
  const redirectUrl = searchParams.get("returnUrl") ?? Utils.getHomeRoute();
  const isLoggedIn = !!Cookies.get("user");
  const hasMcpReturnTo = returnTo && Utils.validateReturnToUrl(returnTo, config.mcpAllowedReturnToPrefixes);

  const [mcpRedirectFailed, setMcpRedirectFailed] = useState(false);

  useEffect(() => {
    if (isLoggedIn && hasMcpReturnTo) {
      userService
        .getMcpRedirectUrl(returnTo, mcpState)
        .then((response) => {
          window.location.href = response.data.redirectUrl;
        })
        .catch(() => setMcpRedirectFailed(true));
    }
  }, []);

  if (!isLoggedIn) {
    return (
      <Login
        onOktaDetected={onOktaDetected}
        oktaConfigUpdated={oktaConfigUpdated}
      />
    );
  }

  if (hasMcpReturnTo && !mcpRedirectFailed) {
    return null;
  }

  return <Navigate to={redirectUrl} />;
}

export default LogInRoute;
